function InstagramWhite() {
  return (
    <svg
      width={41}
      height={40}
      viewBox="0 0 41 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="instagramWhite-icon"
    >
      <path
        d="M20.009 9.745A10.24 10.24 0 009.753 20 10.24 10.24 0 0020.01 30.256 10.24 10.24 0 0030.264 20 10.24 10.24 0 0020.01 9.745zm0 16.922c-3.669 0-6.668-2.99-6.668-6.667a6.674 6.674 0 016.668-6.667A6.674 6.674 0 0126.676 20c0 3.677-2.999 6.667-6.667 6.667zM33.076 9.325a2.387 2.387 0 01-2.392 2.392 2.392 2.392 0 112.392-2.392zm6.792 2.428c-.151-3.205-.883-6.043-3.23-8.381C34.297 1.033 31.46.302 28.255.14c-3.302-.188-13.2-.188-16.503 0-3.196.151-6.034.883-8.381 3.222C1.024 5.7.302 8.54.14 11.743c-.188 3.303-.188 13.202 0 16.504.151 3.204.883 6.043 3.23 8.381 2.348 2.339 5.177 3.07 8.382 3.231 3.302.188 13.2.188 16.503 0 3.204-.151 6.043-.883 8.381-3.23 2.339-2.34 3.07-5.177 3.231-8.382.188-3.302.188-13.192 0-16.494zM35.602 31.79a6.75 6.75 0 01-3.802 3.802c-2.633 1.044-8.881.803-11.791.803s-9.167.232-11.79-.803a6.75 6.75 0 01-3.803-3.802C3.372 29.158 3.613 22.91 3.613 20s-.232-9.167.803-11.79a6.75 6.75 0 013.802-3.803c2.633-1.044 8.881-.803 11.79-.803 2.91 0 9.168-.232 11.792.803a6.75 6.75 0 013.802 3.802c1.044 2.633.803 8.881.803 11.791s.241 9.167-.803 11.79z"
        fill="#ffffff"
      />
    </svg>
  );
}

export default InstagramWhite;
